import { render, staticRenderFns } from "./TwitterSection.vue?vue&type=template&id=203feaef&"
import script from "./TwitterSection.vue?vue&type=script&lang=js&"
export * from "./TwitterSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports